var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFuelStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2066_24086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5871 14.8881V1.79079C12.5871 0.970016 11.9036 0.307251 11.0572 0.307251H3.0008C2.15442 0.307251 1.47098 0.970016 1.47098 1.79079V14.9232",
    stroke: "#D4BC87",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.578 14.9232H13.1302C13.4561 14.9232 13.7231 15.1778 13.7231 15.4982V16.9422C13.7231 17.2582 13.4606 17.5172 13.1302 17.5172H0.923317C0.597438 17.5172 0.330399 17.2626 0.330399 16.9422V15.4982C0.330399 15.1821 0.592912 14.9232 0.923317 14.9232H1.47097",
    stroke: "#D4BC87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.97099 3.29626H4.08707V8.16386H9.97099V3.29626Z",
    stroke: "#D4BC87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5871 6.29407C14.2617 6.29407 14.3115 7.32553 14.3115 8.16386C14.3115 9.00219 14.3115 12.6408 14.3115 13.4265C14.3115 15.0988 16.5429 15.147 16.5429 13.4265C16.5429 11.7059 16.5429 4.52523 16.5429 4.52523L13.9766 3.29626",
    stroke: "#D4BC87",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7734 4.15656C15.5335 4.33651 15.3797 4.59986 15.3797 4.89833C15.3797 5.4338 15.8775 5.86833 16.4976 5.86833V4.52525L15.7734 4.15656Z",
    fill: "#D4BC87"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2066_24086"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuelStop);
export default __webpack_public_path__ + "static/media/fuel-stop.048ec6d8e9bab7d648a52f1537efcbd9.svg";
export { ForwardRef as ReactComponent };